import { Link } from "@tanstack/react-router";
import { MessageSquare, Users, Sparkles, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackIaNav } from "@/lib/analytics";
import { useT } from "@/i18n/LocaleProvider";


export function PillarsBanner() {
  const t = useT();
  const PILLARS = [
    { icon: MessageSquare, ...t.pillars.chat },
    { icon: Users, ...t.pillars.crm },
    { icon: Sparkles, ...t.pillars.ai },
  ];
  return (
    <section
      aria-label={t.pillars.badge}
      className="relative overflow-hidden border-b border-white/5 bg-gradient-to-b from-background via-background to-background/60 pt-28 pb-12 md:pt-32"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
      <div className="absolute -top-32 left-1/2 size-[520px] -translate-x-1/2 rounded-full bg-primary/15 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-500 text-center">
          <span className="glass-card inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-primary-glow">
            <Sparkles className="size-3.5" /> {t.pillars.badge}
          </span>
          <h2
            className="mx-auto mt-4 max-w-4xl text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {t.pillars.titleA}
            <span className="gradient-text">{t.pillars.titleHighlight}</span>
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-muted-foreground md:text-lg">
            {t.pillars.description}
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                className="glass-card group relative overflow-hidden rounded-2xl p-5 animate-in fade-in slide-in-from-bottom-4 duration-500"
                style={{ animationDelay: `${i * 80}ms`, animationFillMode: "backwards" }}
              >
                <div className="flex items-center gap-3">
                  <span className="gradient-primary inline-flex size-10 items-center justify-center rounded-xl text-white shadow-glow">
                    <Icon className="size-5" />
                  </span>
                  <h3 className="text-xl font-bold">{p.title}</h3>
                </div>
                <p className="mt-3 text-sm text-muted-foreground">{p.desc}</p>
              </div>
            );
          })}
        </div>


        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button asChild size="lg" className="gradient-primary text-white shadow-glow hover:opacity-95">
            <Link to="/ia" onClick={() => trackIaNav("pillars_banner_primary")}>
              {t.pillars.ctaPrimary} <ArrowRight />
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="border-white/15 bg-white/5 text-foreground hover:bg-white/10">
            <Link to="/ia" onClick={() => trackIaNav("pillars_banner_secondary")}>
              {t.pillars.ctaSecondary}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
